(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zor-cart-ship"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind() {
    if (window.zorLiveCartBound || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    window.zorLiveCartBound = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      var ids = [].slice.call(document.querySelectorAll('[data-zor-live]')).map(function (m) {
        var s = m.closest('.shopify-section');
        return s ? s.id.replace(/^shopify-section-/, '') : null;
      }).filter(Boolean);
      if (!ids.length) return;
      fetch(window.location.pathname + '?sections=' + ids.join(','))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          ids.forEach(function (id) {
            var el = document.getElementById('shopify-section-' + id);
            if (!el || !data[id]) return;
            var doc = new DOMParser().parseFromString(data[id], 'text/html');
            var fresh = doc.getElementById('shopify-section-' + id);
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
        })
        .catch(function () {});
    });
    }
    // pubsub.js is deferred: bind once the DOM (and deferred scripts) are ready
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zor-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRail(rail) {
      if (rail.dataset.zorRailInit) return;
      var track = rail.querySelector('[data-zor-rail-track]');
      if (!track) return;
      rail.dataset.zorRailInit = '1';

      var prev = rail.querySelector('[data-zor-rail-prev]');
      var next = rail.querySelector('[data-zor-rail-next]');

      function step() {
        var item = track.querySelector('.zor-rail__item');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        // Advance by whole cards, but never more than a screenful.
        var by = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
        return Math.max(by, Math.min(track.clientWidth, by * Math.floor(track.clientWidth / by)));
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= max;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-zor-rail]').forEach(initRail);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zor-fabrics"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFabrics(root) {
      var scope = root || document;
      var lightbox = document.querySelector('[data-zor-lightbox]');
      if (!lightbox) return;
      var lbImg = lightbox.querySelector('[data-lightbox-img]');
      function open(src) { if (!src) return; lbImg.src = src; lightbox.classList.add('is-open'); lightbox.setAttribute('aria-hidden', 'false'); }
      function close() { lightbox.classList.remove('is-open'); lightbox.setAttribute('aria-hidden', 'true'); lbImg.src = ''; }
      scope.querySelectorAll('[data-fab-full]').forEach(function (btn) {
        if (btn.dataset.zorBound) return;
        btn.dataset.zorBound = '1';
        btn.addEventListener('click', function () { open(btn.getAttribute('data-fab-full')); });
      });
      if (!lightbox.dataset.zorBound) {
        lightbox.dataset.zorBound = '1';
        lightbox.addEventListener('click', function (e) { if (e.target === lightbox || e.target.hasAttribute('data-lightbox-close')) close(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      }
    }
    if (document.readyState !== 'loading') initFabrics();
    else document.addEventListener('DOMContentLoaded', function () { initFabrics(); });
    document.addEventListener('shopify:section:load', function (e) { initFabrics(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zor-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(section) {
      if (section.dataset.zorInit) return;
      section.dataset.zorInit = '1';
      var phone = window.matchMedia('(max-width: 749px)').matches;
      var layers = Array.prototype.slice.call(section.querySelectorAll('.zor-hero__layer')).filter(function (el) {
        // slides marked "hide on mobile" are left out of the phone slideshow entirely
        return !(phone && el.hasAttribute('data-hide-mobile'));
      });
      var rail = section.querySelector('.zor-hero__rail');
      var N = layers.length;
      if (!N || !rail) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var videos = Array.prototype.slice.call(section.querySelectorAll('.zor-hero__video'));

      // Rotating the phone (or resizing past the breakpoint) swaps to the cut that
      // fits the new shape, keeping the playhead so the loop doesn't jump.
      var shapeMq = window.matchMedia('(max-width: 749px), (orientation: portrait)');
      var onShape = function () {
        videos.forEach(function (v) {
          if (!v.dataset.srcM || v.dataset.skipped || !v.getAttribute('src')) return;
          var mode = shapeMq.matches ? 'm' : 'd';
          if (v.dataset.mode === mode) return;
          var t = v.currentTime || 0;
          v.dataset.mode = mode;
          var lite = !!v.dataset.lite;
          v.src = mode === 'm' ? ((lite && v.dataset.srcMLite) || v.dataset.srcM) : ((lite && v.dataset.srcDLite) || v.dataset.srcD);
          v.addEventListener('loadedmetadata', function once() {
            v.removeEventListener('loadedmetadata', once);
            try { v.currentTime = t % (v.duration || 1); } catch (e) {}
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          });
        });
      };
      if (shapeMq.addEventListener) shapeMq.addEventListener('change', onShape);
      else if (shapeMq.addListener) shapeMq.addListener(onShape);

      // Reduced motion: hold any video on its first frame rather than looping
      if (reduce) {
        videos.forEach(function (v) {
          v.removeAttribute('autoplay');
          v.removeAttribute('loop');
          try { v.pause(); } catch (e) {}
        });
      } else if (videos.length) {
        // Some browsers refuse autoplay (iOS Low Power Mode, data-saver, etc.).
        // When that happens we swap in an animated WebP; iOS treats that as an
        // image, so it loops without any tap.
        //
        // The hard part is telling "refused" apart from "still downloading". A
        // phone that simply hasn't buffered yet must NOT trip this fallback: the
        // WebP is heavier than the video and lower quality, so mistaking one for
        // the other shows a soft frame AND starves the video of the bandwidth it
        // was waiting on — which is exactly the "pixelated until you tap" bug.
        // So: only an explicit NotAllowedError, or a video that has frames and
        // still won't run, counts as blocked.
        var showStill = function (v, on) {
          var layer = v.closest('.zor-hero__layer');
          if (!layer) return;
          layer.classList.toggle('is-still', on);
          if (!on) return;
          var still = layer.querySelector('.zor-hero__still');
          if (!still || still.dataset.loopOn) return;
          still.dataset.loopOn = '1';

          var small = window.matchMedia('(max-width: 749px), (orientation: portrait)').matches;

          // 1. Paint a sharp still shaped for THIS viewport. The srcs live in
          //    data- attributes so nothing is fetched on the normal path, and a
          //    landscape file is never upscaled into a portrait hero.
          var poster = (small && still.dataset.stillMobile) || still.dataset.still;
          if (poster) still.src = poster;

          // 2. Decode the animated loop off-screen, and only swap once it's ready
          //    so the visitor never sees a half-loaded or wrongly-sized frame.
          var loop = (small && still.dataset.loopSrcMobile) || still.dataset.loopSrc;
          if (!loop) return;
          var pre = new Image();
          pre.onload = function () { still.src = loop; };
          pre.src = loop;
        };

        var gestures = ['touchstart', 'pointerdown', 'keydown'];

        var tryPlay = function () {
          videos.forEach(function (v) {
            if (!v.getAttribute('src')) return; // not released yet, or skipped on a slow link
            if (!v.paused) return;          // already running — don't interrupt it
            v.muted = true;                 // must be set before play() on iOS
            v.setAttribute('muted', '');
            var p = v.play();
            if (!p || typeof p.catch !== 'function') return;
            p.catch(function (err) {
              // AbortError just means this play() was superseded by another
              // load/play — not a policy block, so it must not force the still.
              if (err && err.name === 'NotAllowedError') showStill(v, true);
            });
          });
        };

        var retry = function () { tryPlay(); };

        var unbindRetry = function () {
          if (videos.some(function (v) { return v.paused; })) return;
          gestures.forEach(function (ev) { window.removeEventListener(ev, retry); });
        };

        videos.forEach(function (v) {
          v.addEventListener('playing', function () {
            v.classList.add('is-playing');
            showStill(v, false);
            unbindRetry();
          });
          // Retry once there are decodable frames: an autoplay attempt made
          // before the first frame lands can stall without ever being refused.
          v.addEventListener('loadeddata', tryPlay);
          v.addEventListener('canplay', tryPlay);
        });

        tryPlay();

        // Backstop, generous enough to clear buffering on a slow phone. Gated on
        // readyState so a video that is merely still downloading is left alone.
        setTimeout(function () {
          videos.forEach(function (v) {
            if (v.paused && v.readyState >= 2) showStill(v, true);
          });
        }, 4000);

        // Retry on the first real user gesture (scroll is not one, and firing
        // play() on every scroll frame only produced spurious rejections).
        gestures.forEach(function (ev) {
          window.addEventListener(ev, retry, { passive: true });
        });
        // resume if the tab/app comes back to the foreground
        document.addEventListener('visibilitychange', function () {
          if (!document.hidden) tryPlay();
        });
      }

      // A single look needs no progress rail and no auto-advance
      if (N < 2) {
        rail.style.display = 'none';
        layers[0].classList.add('is-active');
        return;
      }

      function restartAnim(el) {
        if (!el) return;
        el.style.animation = 'none';
        void el.offsetWidth;
        el.style.animation = '';
      }

      var current = -1;
      var bars = layers.map(function (_, i) {
        var b = document.createElement('button');
        b.className = 'zor-hero__bar';
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Show look ' + (i + 1));
        b.innerHTML = '<span class="zor-hero__fill"></span>';
        b.addEventListener('click', function () { go(i); });
        rail.appendChild(b);
        return b;
      });

      function go(i) {
        if (i === current) return;
        current = i;
        layers.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
        bars.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
        restartAnim(bars[i].querySelector('.zor-hero__fill'));
        var img = layers[i].querySelector('img');
        if (img) restartAnim(img);
      }

      if (reduce) { go(0); return; }

      bars.forEach(function (b, i) {
        b.querySelector('.zor-hero__fill').addEventListener('animationend', function () {
          if (i === current && !section.classList.contains('is-paused')) go((current + 1) % N);
        });
      });

      section.addEventListener('mouseenter', function () { section.classList.add('is-paused'); });
      section.addEventListener('mouseleave', function () { section.classList.remove('is-paused'); });
      document.addEventListener('visibilitychange', function () {
        section.classList.toggle('is-paused', document.hidden);
      });

      go(0);
    }

    function initAll(root) {
      (root || document).querySelectorAll('.zor-hero').forEach(initHero);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zor-lookbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initLook(section) {
      if (section.dataset.zorLookInit) return;
      var stage = section.querySelector('[data-look-stage]');
      var ring = section.querySelector('[data-look-rot]');
      if (!stage || !ring) return;
      var cards = Array.prototype.slice.call(ring.querySelectorAll('.zor-look__card'));
      var N = cards.length;
      if (!N) return;
      section.dataset.zorLookInit = '1';

      var names = section.querySelector('.zor-look__names');
      var nameEl = section.querySelector('[data-look-name]');
      var priceEl = section.querySelector('[data-look-price]');
      var idxEl = section.querySelector('[data-look-index]');
      var ctaEl = section.querySelector('[data-look-cta]');
      var segs = Array.prototype.slice.call(section.querySelectorAll('.zor-look__seg'));
      var defaultHref = ctaEl ? ctaEl.getAttribute('href') : '';

      var index = 0, drag = 0, spacing = 220;
      var timer = null, interval = (parseFloat(section.dataset.interval) || 6) * 1000;
      var hovering = false, focused = false, visible = false, userStopped = false;

      function wrap(off) {
        if (off > N / 2) off -= N;
        if (off < -N / 2) off += N;
        return off;
      }
      function measure() {
        var w = cards[0].offsetWidth || 260;
        spacing = w * (window.innerWidth < 821 ? 0.72 : 0.64);
      }
      function layout() {
        var pos = index + drag;
        cards.forEach(function (c, i) {
          var off = N > 1 ? wrap(i - pos) : 0;
          var a = Math.abs(off);
          var hidden = a > 2.2;
          var x = off * spacing;
          var ry = reduce ? 0 : Math.max(-40, Math.min(40, -off * 22));
          var tz = reduce ? 0 : -Math.min(a, 2) * 130;
          var sc = 1 - Math.min(a, 2) * 0.07;
          c.style.transform = 'translate(-50%,-50%) translate3d(' + x + 'px,0,' + tz + 'px) rotateY(' + ry + 'deg) scale(' + sc + ')';
          c.style.opacity = hidden ? '0' : String(1 - Math.max(0, a - 1) * 0.55);
          c.style.zIndex = String(100 - Math.round(a * 10));
          c.style.pointerEvents = hidden ? 'none' : '';
          c.style.setProperty('--shade', String(Math.min(a, 1.6) * 0.32));
          c.setAttribute('aria-hidden', Math.round(a) === 0 ? 'false' : 'true');
          c.tabIndex = Math.round(a) === 0 ? 0 : -1;
        });
      }

      /* ---------- video: only the front card loads + plays ---------- */
      function videoOf(c) { return c.querySelector('video[data-src], video.is-loaded'); }
      function play(c) {
        var v = videoOf(c);
        if (!v || reduce) return;
        if (v.dataset.src) { v.src = v.dataset.src; v.removeAttribute('data-src'); v.classList.add('is-loaded'); }
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        if (!v.dataset.bound) {
          v.dataset.bound = '1';
          v.addEventListener('playing', function () { c.classList.add('is-playing'); });
        }
      }
      function pause(c) {
        var v = c.querySelector('video');
        if (v && !v.paused) v.pause();
        c.classList.remove('is-playing');
      }
      function syncVideo() {
        cards.forEach(function (c, i) { if (i === index && visible) play(c); else pause(c); });
      }

      function setCopy(i) {
        var c = cards[i];
        cards.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
        if (nameEl) nameEl.textContent = c.dataset.name;
        if (priceEl) priceEl.textContent = c.dataset.price;
        if (idxEl) idxEl.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        if (names) { names.classList.remove('is-swapping'); void names.offsetWidth; names.classList.add('is-swapping'); }
        if (ctaEl) {
          var href = c.getAttribute('href');
          ctaEl.setAttribute('href', href && href !== '#' ? href : defaultHref);
        }
        segs.forEach(function (s, k) {
          s.classList.toggle('is-done', k < i);
          s.classList.remove('is-active');
        });
        if (segs[i]) { void segs[i].offsetWidth; segs[i].classList.add('is-active'); }
      }

      function go(i) {
        index = ((i % N) + N) % N;
        drag = 0;
        layout();
        setCopy(index);
        syncVideo();
        schedule();
      }

      /* ---------- auto-advance (pauses on hover, focus, hidden tab, off screen) ---------- */
      function running() { return !reduce && visible && !hovering && !focused && !userStopped && !document.hidden && N > 1; }
      function schedule() {
        clearTimeout(timer);
        section.classList.toggle('is-paused', !running());
        section.classList.toggle('is-static', reduce || N < 2);
        // the CSS progress bar is the clock: advance when it finishes
      }
      segs.forEach(function (s, k) {
        var fill = s.querySelector('i');
        fill && fill.addEventListener('animationend', function () { if (k === index && running()) go(index + 1); });
      });
      function refresh() { schedule(); syncVideo(); }

      // Pause while the pointer is anywhere over the section (photos, copy or the
      // CTA), so the look can't change under the shopper on the way to the button.
      section.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovering = true; schedule(); } });
      section.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hovering = false; schedule(); } });
      // Touch: once the shopper touches the lookbook they are in control; stop auto-play.
      section.addEventListener('touchstart', function () { if (!userStopped) { userStopped = true; schedule(); } }, { passive: true });
      section.addEventListener('focusin', function (e) {
        // keyboard focus pauses; a mouse click on an arrow should not stop the show
        var t = e.target;
        focused = !!(t && t.matches && t.matches(':focus-visible'));
        schedule();
      });
      section.addEventListener('focusout', function () { focused = section.contains(document.activeElement); schedule(); });
      document.addEventListener('visibilitychange', refresh);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          refresh();
        }, { threshold: 0.35 }).observe(stage);
      } else { visible = true; }

      /* ---------- drag / swipe with momentum snap ---------- */
      var down = false, startX = 0, startY = 0, lastX = 0, lastT = 0, vx = 0, moved = 0, axis = '';
      stage.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        down = true; axis = ''; moved = 0; vx = 0;
        startX = lastX = e.clientX; startY = e.clientY; lastT = performance.now();
      });
      stage.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        if (!axis) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (axis === 'x') { stage.classList.add('is-grabbing'); try { stage.setPointerCapture(e.pointerId); } catch (err) {} }
        }
        if (axis !== 'x') return;
        var now = performance.now();
        vx = (e.clientX - lastX) / Math.max(1, now - lastT);
        lastX = e.clientX; lastT = now;
        moved = Math.abs(dx);
        drag = -dx / spacing;
        layout();
      });
      function release() {
        if (!down) return;
        down = false;
        stage.classList.remove('is-grabbing');
        if (axis !== 'x') return;
        // a quick flick moves one look even if the drag was short
        var shift = Math.round(drag);
        if (shift === 0 && Math.abs(vx) > 0.35) shift = vx < 0 ? 1 : -1;
        go(index + shift);
      }
      stage.addEventListener('pointerup', release);
      stage.addEventListener('pointercancel', release);

      cards.forEach(function (c, i) {
        c.addEventListener('click', function (e) {
          if (moved > 8) { e.preventDefault(); moved = 0; return; }
          if (i !== index) { e.preventDefault(); go(i); return; }
          if (c.getAttribute('href') === '#') e.preventDefault();
        });
      });
      // The CTA always opens the look that is in front at the moment of the click.
      if (ctaEl) {
        ctaEl.addEventListener('click', function (e) {
          var href = cards[index] && cards[index].getAttribute('href');
          if (href && href !== '#' && href !== ctaEl.getAttribute('href')) {
            e.preventDefault();
            window.location.href = href;
          }
        });
      }

      var prev = section.querySelector('[data-look-prev]');
      var next = section.querySelector('[data-look-next]');
      prev && prev.addEventListener('click', function () { go(index - 1); });
      next && next.addEventListener('click', function () { go(index + 1); });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });

      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { measure(); layout(); }, 120);
      });
      measure();
      layout();
      setCopy(0);
      schedule();
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-zor-look]').forEach(initLook);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zor-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function applyCode(form) {
      var c = form.querySelector('[data-zor-news-code]');
      if (!c) return;
      var code = c.textContent.trim();
      // sets the discount cookie so the code is pre-applied at checkout
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(function () {});
      var copy = form.querySelector('[data-zor-news-copy]');
      copy && copy.addEventListener('click', function () {
        var done = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 1800); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      });
    }

    function showError(form, msg) {
      var err = form.querySelector('.zor-news__err');
      if (!err) { err = document.createElement('p'); err.className = 'zor-news__err'; err.setAttribute('role', 'alert'); form.appendChild(err); }
      err.textContent = msg;
      var input = form.querySelector('input[type="email"]');
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
    }

    function bind(form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      if (form.querySelector('.zor-news__ok')) { applyCode(form); return; }

      // Submit natively: Shopify's invisible CAPTCHA attaches its token on a real
      // submit, and a background fetch (or form.submit()) skips it and gets
      // rejected with "Invalid CAPTCHA token". The page returns to #ZorNewsForm
      // with the success message. Only a mistyped email is stopped here.
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('input[type="email"]');
        var btn = form.querySelector('button[type="submit"]');
        if (!input) return;
        input.value = input.value.trim();
        if (!EMAIL.test(input.value)) { e.preventDefault(); showError(form, 'Please enter a valid email address.'); return; }
        input.removeAttribute('aria-invalid');
        if (btn) { btn.textContent = 'Joining\u2026'; btn.setAttribute('aria-busy', 'true'); }
      });
    }

    function init(root) { (root || document).querySelectorAll('#ZorNewsForm').forEach(bind); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zor-popup"]) return;
  try {
    
  (function () {
    var KEY = 'zor-popup-seen-v3'; // bumped when the offer changes, so it shows once again
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    function init() {
      var pop = document.querySelector('[data-zor-pop]');
      if (!pop || pop.dataset.zorPopInit) return;
      pop.dataset.zorPopInit = '1';
      var days = parseInt(pop.getAttribute('data-days'), 10) || 30;
      var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 0) * 1000;
      var inEditor = !!(window.Shopify && Shopify.designMode);
      var lastFocus = null;
      function suppressed() {
        try {
          var until = parseInt(localStorage.getItem(KEY), 10);
          return until && Date.now() < until;
        } catch (e) { return false; }
      }
      function suppress() {
        try { localStorage.setItem(KEY, String(Date.now() + days * 864e5)); } catch (e) {}
      }
      // never interrupt a shopper who is mid-purchase
      function busy() {
        var d = document.querySelector('[data-zor-added]');
        return (d && d.open) || /^\/(cart|checkout|account)/.test(location.pathname);
      }
      function open() {
        if (!pop.hidden) return;
        lastFocus = document.activeElement;
        pop.hidden = false;
        document.body.style.overflow = 'hidden';
        var first = pop.querySelector('[data-zor-pop-done]') || pop.querySelector('[data-zor-pop-claim]') || pop.querySelector('[data-zor-pop-banner]') || pop.querySelector('input:not([type=hidden])');
        if (first && window.matchMedia('(min-width: 750px)').matches) first.focus({ preventScroll: true });
        else { var x = pop.querySelector('.zor-pop__x'); x && x.focus({ preventScroll: true }); }
      }
      function close() {
        pop.hidden = true;
        document.body.style.overflow = '';
        suppress();
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
      function bindClose(root) {
        root.querySelectorAll('[data-zor-pop-close]').forEach(function (b) {
          if (b.dataset.bound) return;
          b.dataset.bound = '1';
          b.addEventListener('click', close);
        });
      }
      bindClose(pop);
      document.addEventListener('keydown', function (e) {
        if (pop.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') {
          // keep keyboard focus inside the dialog
          var f = Array.prototype.filter.call(pop.querySelectorAll('button, input:not([type=hidden]), a[href]'), function (el) { return el.offsetParent !== null; });
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        }
      });

      function onDone() {
        suppress();
        bindClose(pop);
        var c = pop.querySelector('[data-zor-pop-code]');
        if (!c) return;
        var code = c.textContent.trim();
        // pre-apply the code so it is already on the order at checkout
        fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(function () {});
        var copy = pop.querySelector('[data-zor-pop-copy]');
        copy && copy.addEventListener('click', function () {
          var ok = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 1800); };
          if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, ok); else ok();
        });
      }

      var bannerLink = pop.querySelector('[data-zor-pop-banner]');
      if (bannerLink) bannerLink.addEventListener('click', suppress);

      var claim = pop.querySelector('[data-zor-pop-claim]');
      if (claim) {
        claim.addEventListener('click', function () {
          var reveal = pop.querySelector('[data-zor-pop-reveal]');
          claim.hidden = true;
          if (reveal) {
            reveal.hidden = false;
            reveal.setAttribute('data-zor-pop-done', '');
            reveal.focus({ preventScroll: true });
          }
          onDone();
        });
      }

      var form = pop.querySelector('#ZorPopupForm');
      function showError(msg, field) {
        var err = form.querySelector('.zor-pop__err');
        if (!err) {
          err = document.createElement('div'); err.className = 'zor-pop__err'; err.setAttribute('role', 'alert');
          var fine = form.querySelector('.zor-pop__fine');
          form.insertBefore(err, fine);
        }
        err.textContent = msg;
        if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
      }
      if (form && !pop.querySelector('[data-zor-pop-done]')) {
        // Native submit so Shopify's CAPTCHA can attach its token (a background
        // fetch is rejected). The reload reopens the popup with the code.
        form.addEventListener('submit', function (e) {
          var email = form.querySelector('input[type="email"]');
          var phone = form.querySelector('input[type="tel"]');
          var btn = form.querySelector('button[type="submit"]');
          if (!email) return;
          email.value = email.value.trim();
          if (!EMAIL.test(email.value)) { e.preventDefault(); showError('Please enter a valid email address.', email); return; }
          email.removeAttribute('aria-invalid');
          if (phone && phone.value.trim() && phone.value.replace(/\D/g, '').length < 10) { e.preventDefault(); showError('Please check your mobile number.', phone); return; }
          if (btn) btn.textContent = 'One moment\u2026';
        });
      }

      // A non-JS / captcha signup renders the code on reload: show it once.
      if (pop.querySelector('[data-zor-pop-done]')) { open(); onDone(); return; }
      // In the theme editor always show it, so the section can actually be edited.
      if (inEditor) { open(); return; }
      if (suppressed()) return;
      window.setTimeout(function tryOpen() {
        if (busy()) { window.setTimeout(tryOpen, 4000); return; }
        open();
      }, delay);
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zor-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPDP(root) {
      var scope = root || document;
      var pdp = scope.querySelector('[data-zor-pdp]');
      if (!pdp || pdp.dataset.zorInit) return;
      pdp.dataset.zorInit = '1';

      // ---- quantity
      var qtyInput = pdp.querySelector('[data-qty-input]');
      pdp.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = parseInt(b.getAttribute('data-qty'), 10);
          var v = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = Math.max(1, v + step);
        });
      });

      // ---- variants
      var dataEl = document.querySelector('[data-pdp-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var idField = pdp.querySelector('[data-pdp-variant-id]');
      var atc = pdp.querySelector('[data-pdp-atc]');
      var priceWrap = pdp.querySelector('[data-pdp-price]');
      var stickyPrice = document.querySelector('[data-sticky-price]');

      // Format using the shop's own money_format pattern (e.g. Rs. or $ prefixed)
      var fmtEl = document.querySelector('[data-money-format]');
      var moneyFormat = fmtEl ? fmtEl.getAttribute('data-money-format') : '';
      function money(cents) {
        if (window.Shopify && typeof Shopify.formatMoney === 'function') {
          return Shopify.formatMoney(cents, moneyFormat);
        }
        var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (moneyFormat) {
          var out = moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, n);
          if (out !== moneyFormat) return out;
        }
        return n;
      }

      function selectedOptions() {
        var out = [];
        pdp.querySelectorAll('.zor-opt__input:checked').forEach(function (i) {
          out[parseInt(i.getAttribute('data-opt-pos'), 10) - 1] = i.value;
        });
        return out;
      }

      // ---- size helpers (size must be chosen before adding)
      var sizeGroup = pdp.querySelector('[data-opt-size]');
      var sizePos = sizeGroup ? sizeGroup.getAttribute('data-opt-index') : null;
      var stickyBar = document.querySelector('[data-pdp-sticky]');
      var stickySizes = [].slice.call(document.querySelectorAll('[data-sticky-size]'));
      function sizeInputs() {
        return sizePos ? [].slice.call(pdp.querySelectorAll('.zor-opt__input[data-opt-pos="' + sizePos + '"]')) : [];
      }
      function sizeMissing() {
        return !!sizeGroup && !sizeInputs().some(function (i) { return i.checked; });
      }
      function clearMissing() {
        if (sizeGroup) sizeGroup.classList.remove('is-missing');
        if (stickyBar) stickyBar.classList.remove('is-missing');
      }
      function flagMissing(fromSticky) {
        var target = fromSticky && stickySizes.length ? stickyBar : sizeGroup;
        if (!target) return;
        if (sizeGroup) sizeGroup.classList.add('is-missing');
        if (stickyBar && stickySizes.length) stickyBar.classList.add('is-missing');
        var shake = fromSticky && stickySizes.length ? stickyBar.querySelector('.zor-sticky__sizes') : sizeGroup;
        shake.classList.remove('is-shaking'); void shake.offsetWidth; shake.classList.add('is-shaking');
        if (!fromSticky) {
          var r = sizeGroup.getBoundingClientRect();
          if (r.top < 80 || r.bottom > window.innerHeight) sizeGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var first = sizeInputs()[0];
          if (first) first.focus({ preventScroll: true });
        }
      }
      // grey out sizes with no stock in the current colour
      function paintSizes(sel) {
        if (!sizePos) return;
        var idx = parseInt(sizePos, 10) - 1;
        sizeInputs().forEach(function (input) {
          var ok = variants.some(function (v) {
            return v.available && v.options[idx] === input.value &&
              sel.every(function (val, i) { return i === idx || !val || v.options[i] === val; });
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-oos', !ok);
          var chip = stickySizes.filter(function (c) { return c.getAttribute('data-sticky-size') === input.value; })[0];
          if (chip) {
            chip.disabled = !ok;
            chip.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
          }
        });
      }
      stickySizes.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var v = chip.getAttribute('data-sticky-size');
          var input = sizeInputs().filter(function (i) { return i.value === v; })[0];
          if (!input) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      function update() {
        var sel = selectedOptions();
        var match = variants.find(function (v) {
          return sel.every(function (val, i) { return !val || v.options[i] === val; });
        });
        // reflect chosen values in labels
        pdp.querySelectorAll('[data-opt-selected]').forEach(function (el) {
          var pos = el.getAttribute('data-opt-selected');
          var picked = pdp.querySelector('.zor-opt__input[data-opt-pos="' + pos + '"]:checked');
          if (picked) el.textContent = picked.value;
        });
        if (!match) {
          if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
          return;
        }
        if (idField) idField.value = match.id;
        var needSize = sizeMissing();
        if (atc) {
          atc.disabled = !needSize && !match.available;
          atc.textContent = needSize ? 'Select a size' : (match.available ? 'Add to Bag' : 'Sold Out');
        }
        if (!needSize) clearMissing();
        paintSizes(sel);
        if (priceWrap) {
          var now = priceWrap.querySelector('.zor-pdp__now');
          if (now) now.textContent = money(match.price);
          var was = priceWrap.querySelector('.zor-pdp__was');
          if (was) {
            if (match.compare_at_price && match.compare_at_price > match.price) {
              was.textContent = money(match.compare_at_price);
              was.style.display = '';
            } else { was.style.display = 'none'; }
          }
        }
        if (stickyPrice) stickyPrice.textContent = money(match.price);
      }

      pdp.querySelectorAll('.zor-opt__input').forEach(function (i) {
        i.addEventListener('change', update);
      });
      update();

      // ---- Add to Bag: stay on the page and confirm in the "Added to bag" sheet.
      // Falls back to the normal form post (-> /cart) if the helper is missing.
      var form = pdp.querySelector('form.zor-pdp__form');
      if (form && atc && !form.dataset.zorAjax) {
        form.dataset.zorAjax = '1';
        var errEl = document.createElement('p');
        errEl.className = 'zor-pdp__err';
        errEl.setAttribute('role', 'alert');
        errEl.hidden = true;
        form.appendChild(errEl);
        var pairEl = pdp.parentNode.querySelector('[data-pdp-pair]') || document.querySelector('[data-pdp-pair]');
        var pair = null;
        try { pair = pairEl ? JSON.parse(pairEl.textContent) : null; } catch (err) { pair = null; }
        form.addEventListener('submit', function (e) {
          if (sizeMissing()) {
            e.preventDefault();
            flagMissing(form.dataset.fromSticky === '1');
            form.dataset.fromSticky = '';
            return;
          }
          form.dataset.fromSticky = '';
          if (!window.ZorBag || typeof FormData === 'undefined') return;
          e.preventDefault();
          if (atc.disabled) return;
          var label = atc.textContent;
          atc.disabled = true;
          atc.textContent = 'Adding\u2026';
          errEl.hidden = true;
          window.ZorBag.add(new FormData(form), { pair: pair })
            .catch(function (err) {
              errEl.textContent = err.userMessage || 'Something went wrong. Please try again.';
              errEl.hidden = false;
            })
            .then(function () {
              atc.disabled = false;
              atc.textContent = label;
            });
        });
      }

      // ---- sticky bar: show once the main ATC scrolls out of view
      var sticky = document.querySelector('[data-pdp-sticky]');
      var stickyBtn = document.querySelector('[data-sticky-atc]');
      if (stickyBtn && atc) {
        stickyBtn.addEventListener('click', function () {
          var f = atc.form;
          if (f) f.dataset.fromSticky = '1';
          if (f && typeof f.requestSubmit === 'function') f.requestSubmit(atc); else atc.click();
        });
      }
      if (sticky && atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            sticky.classList.toggle('is-on', !e.isIntersecting);
            sticky.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
          });
        }, { rootMargin: '0px 0px -60px 0px' }).observe(atc);
      }
    }

    if (document.readyState !== 'loading') initPDP();
    else document.addEventListener('DOMContentLoaded', function () { initPDP(); });
    document.addEventListener('shopify:section:load', function (e) { initPDP(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
